<template>
  <div class="app-container">
    <div
      ref="filterContainer"
      class="filter-container"
    >
      <!-- 后退、前进、设置列 -->
      <table-operation
        :init-table-column="masterList.initTableColumn"
        :table-columns.sync="masterList.tableColumns"
        :table-key="masterList.tableKey"
        :table-index.sync="masterList.tableIndex"
        :search-condition.sync="masterList.tableQuery"
        :table-transfer-name="getTransferName()"
        :todo-list.sync="todoList"
        show-to-do
        @reloadData="requestData()"
        @task="taskFun"
      />
    </div>
    <div class="container-box">
      <!-- 查询条件 -->
      <div ref="searchCondition">
        <el-row :gutter="10">
          <el-col style="width:40px;padding-left:10px;">
            <el-button
              type="text"
              style=""
            >
              查询：
            </el-button>
          </el-col>
          <el-col
            :xs="8"
            :sm="6"
            :md="4"
            :lg="3"
            :xl="2"
          >
            <el-input
              v-model="masterList.tableQuery.search.unionId"
              placeholder="请输入微信统一ID"
              style="width:100%"
              clearable
              @keyup.enter.native="searchData()"
            />
          </el-col>
          <el-col
            :xs="8"
            :sm="6"
            :md="4"
            :lg="3"
            :xl="2"
          >
            <el-input
              v-model="masterList.tableQuery.search.phone"
              placeholder="请输入电话"
              style="width:100%"
              clearable
              @keyup.enter.native="searchData()"
            />
          </el-col>
          <el-col
            :xs="8"
            :sm="6"
            :md="4"
            :lg="3"
            :xl="2"
          >
            <el-select
              v-model="masterList.tableQuery.search.status"
              placeholder="请选择状态"
              clearable
              style="width:100%"
            >
              <el-option
                value="1"
                label="草稿"
              />
              <el-option
                value="2"
                label="发布"
              />
            </el-select>
          </el-col>
          <el-col
            :xs="12"
            :sm="8"
            :md="6"
            :lg="4"
            :xl="3"
          >
            <el-button
              type="primary"
              @click="searchData()"
            >
              查询
            </el-button>
          </el-col>
        </el-row>
      </div>
      <!-- 数据列表 -->
      <custom-table
        :ref="masterList.tableKey"
        style="margin-top:5px"
        :data-obj="masterList"
        :table-key="masterList.tableKey"
        :table-columns="masterList.tableColumns"
        :table-data="masterList.tableData"
        :loading="masterList.tableLoading"
        :search-condition.sync="masterList.tableQuery"
        :data-total="masterList.tableDataTotal"
        :table-contextmenu="masterList.tableContextmenu"
        :table-custom-height="tableHeight"
        is-index-field
        is-paging
        @reloadData="loadTableData()"
        @batchAdd="batchAddFun"
        @add="addFun"
        @edit="editFun(arguments)"
        @view="viewFun(arguments)"
        @delete="deleteFun(arguments)"
        @publish="publishFun(arguments)"
        @dblclick="viewFun(arguments)"
        @export="batchExport(masterList)"
        @cancelLink="cancelLinkFun(arguments)"
      />
    </div>
    <!-- 批量新增-->
    <batch-add-dialog
      :dialog-title="dialogAddEditViewTitle"
      :dialog-visible.sync="dialogBatchAddVisible"
      :master-table-key="masterList.tableKey"
      @reloadData="loadTableData()"
    />
    <!-- 新增 修改 查看-->
    <add-edit-view-dialog
      :data-id="id"
      :event-type="eventType"
      :dialog-title="dialogAddEditViewTitle"
      :dialog-visible.sync="dialogAddEditViewVisible"
      :master-table-key="masterList.tableKey"
      @reloadData="loadTableData()"
    />
    <!-- 待办列表 -->
    <task-list-dialog
      :dialog-visible.sync="dialogTaskVisible"
      dialog-title="待发布用户消息"
      @reloadData="loadTableData()"
    />
  </div>
</template>

<script>
// Table操作组件（后退、前进、列设置）
import TableOperation from '@/components/TableOperation'
// 列表设置tableKeyMixin
import tableOperationMixin from '@/mixin/tableOperationMixin'
// 导出 batchExportMixin
import batchExportMixin from '@/mixin/batchExportMixin'
// 自定义Table
import CustomTable from '@/components/CustomTable'
// 定义表头颜色，高度，查询，获取数据Mixin
import tableCustomMixin from '@/mixin/tableCustomMixin'
// 批量新增
import batchAddDialog from './components/batchAddDialog'
// 新增 修改
import AddEditViewDialog from './components/addEditViewDialog'
// 代办
import taskListDialog from './components/taskListDialog'
// 数据请求
import { loadAppConsumerMessageListDataApi, loadAppConsumerMessageExportDataApi, saveOrUpdateAppConsumerMessageApi, findAppConsumerMessageCountByConditionApi } from '@/api/appConsumerMessage'

export default {
  name: 'AppConsumerMessage',
  components: {
    CustomTable,
    TableOperation,
    AddEditViewDialog,
    taskListDialog,
    batchAddDialog
  },
  mixins: [tableCustomMixin, tableOperationMixin, batchExportMixin],
  data () {
    return {
      // 主列表
      masterList: {
        initTableColumn: [], // Table初始化列
        tableColumns: [], // Table列
        tableKey: 'app_consumer_message_master', // Table Key
        tableIndex: 0, // Table Index
        tableLoading: true, // Table加载状态
        tableData: [], // Table数据
        tableDataTotal: 0, // Table总数据条数
        // Table右键
        tableContextmenu: [
          {
            permissionSigns: ['app_user_message_add'],
            prop: 'batchAdd',
            label: '批量新增',
            method: 'batchAdd'
          },
          {
            permissionSigns: ['app_user_message_add'],
            prop: 'add',
            label: '新增',
            method: 'add'
          },
          {
            permissionSigns: ['app_user_message_edit'],
            prop: 'edit',
            label: '修改',
            method: 'edit'
          },
          {
            permissionSigns: ['app_user_message_view'],
            prop: 'view',
            label: '查看',
            method: 'view'
          },
          {
            permissionSigns: ['app_user_message_publish'],
            prop: 'publish',
            label: '发布',
            method: 'publish'
          },
          {
            permissionSigns: ['app_user_message_del'],
            prop: 'delete',
            label: '作废',
            method: 'delete'
          },
          {
            permissionSigns: ['app_user_message_export'],
            prop: 'export',
            label: '导出',
            method: 'export'
          }
        ],
        tableQuery: {
          page: 1, // 页数
          limit: 50, // 每页条数
          contextmenuWrap: [], // 右键筛选字段
          // 排序对象
          sort: {
            prop: '', // 排序字段
            order: '' // 排序类型 asc升序 desc降序
          },
          // 查询条件
          search: {
            unionId: '',
            phone: '',
            status: null
          }
        }
      },
      id: null, // 选中的单据ID
      eventType: '',
      dialogAddEditViewTitle: '',
      dialogAddEditViewVisible: false,
      // 待办
      todoList: [
        {
          permissionSigns: ['app_user_message_publish'],
          label: '待发布用户消息信息',
          method: 'task',
          count: 0
        }
      ],
      dialogTaskVisible: false,
      dialogBatchAddVisible: false
    }
  },
  created () {
    // 初始化主列表Table列
    this.masterList.initTableColumn = [
      { prop: 'rowNumber', label: '序号', width: 80 },
      { prop: 'id', filterColumn: 'i.id', label: '编号', width: 80 },
      { prop: 'unionId', filterColumn: 'r.union_id', label: '微信统一ID', width: 160 },
      { prop: 'name', filterColumn: 'r.name', label: '名称', width: 120 },
      { prop: 'phone', filterColumn: 'r.phone', label: '电话', width: 120 },
      { prop: 'provinceName', filterColumn: 'r.province_name', label: '省区', width: 120 },
      { prop: 'messageTitle', filterColumn: 'i.message_title', label: '消息标题', width: 160 },
      { prop: 'messageData', filterColumn: 'i.message_data', label: '消息内容', width: 260 },
      { prop: 'publishTimeStr', filterColumn: 'i.publish_time', label: '发布时间', width: 150 },
      { prop: 'isReadStr', filterColumn: 'i.is_read', filterValue: 'isRead', label: '是否已读', width: 110, filterArray: [{ label: '是', value: 1 }, { label: '否', value: 0 }] },
      { prop: 'readTimeStr', filterColumn: 'i.read_time', label: '已读时间', width: 150 },
      { prop: 'statusStr', filterColumn: 'i.status', filterValue: 'status', label: '状态', width: 200, filterArray: [{ label: '草稿', value: 1 }, { label: '发布', value: 2 }] },
      { prop: 'remark', label: '备注', width: 200 },
      { prop: 'operatorName', filterColumn: 'i.operator_name', label: '操作人', width: 150 },
      { prop: 'operationTimeStr', filterColumn: 'i.operation_time', label: '操作时间', width: 160, isBetween: true },
    ]
    // 默认主列表Table列
    this.getInitTableColumns()
    this.loadTableData()
  },
  methods: {
    // 请求数据
    requestData () {
      this.masterList.tableLoading = true
      let pageCondition = { condition: JSON.stringify(this.masterList.tableQuery) }
      loadAppConsumerMessageListDataApi(pageCondition).then(response => {
        this.masterList.tableLoading = false
        let data = response.data.data ? response.data.data : []
        this.handleData(data)
        this.masterList.tableDataTotal = response.data.recordsTotal
      }).catch()
      this.getTodoCount()
    },
    // 获取待办任务数量
    getTodoCount () {
      let params = { status: 1 }
      findAppConsumerMessageCountByConditionApi(params).then(res => {
        this.todoList[0].count = res.data ? res.data : 0
      })
    },
    taskFun () {
      this.dialogTaskVisible = !this.dialogTaskVisible
    },
    // 批量新增
    batchAddFun () {
      this.eventType = 'add'
      this.dialogBatchAddVisible = !this.dialogBatchAddVisible
      this.dialogAddEditViewTitle = '批量新增用户消息'
    },
    // 新增
    addFun () {
      this.eventType = 'add'
      this.dialogAddEditViewVisible = !this.dialogAddEditViewVisible
      this.dialogAddEditViewTitle = '新增用户消息'
    },
    // 修改
    editFun (args) {
      if (!args[0]) {
        this.$message({
          message: '请选择数据行',
          type: 'warning'
        })
        return
      } else if (args[0].status !== 1) {
        this.$message({
          message: '单据不在草稿状态，不能修改',
          type: 'warning'
        })
        return
      }
      this.id = args[0].id
      this.eventType = 'edit'
      this.dialogAddEditViewVisible = !this.dialogAddEditViewVisible
      this.dialogAddEditViewTitle = '修改用户消息'
    },
    // 查看
    viewFun (args) {
      if (!args[0]) {
        this.$message({
          message: '请选择数据行',
          type: 'warning'
        })
        return
      }
      this.id = args[0].id
      this.eventType = 'view'
      this.dialogAddEditViewVisible = !this.dialogAddEditViewVisible
      this.dialogAddEditViewTitle = '查看用户消息'
    },
    // 作废
    deleteFun (args) {
      if (!args[0]) {
        this.$message({
          message: '请选择数据行',
          type: 'warning'
        })
        return
      } else if (args[0].status !== 1) {
        this.$message({
          message: '单据不在草稿状态，不能作废',
          type: 'warning'
        })
        return
      }
      this.$confirm('是否确定作废该用户消息？', '系统提示',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
          center: true
        }
      ).then(async () => {
        saveOrUpdateAppConsumerMessageApi({ id: args[0].id, isDel: "1" }).then(res => {
          if (res.mark === '200') {
            this.$message({
              message: res.message,
              type: 'success'
            })
            this.loadTableData()
          }
        })
      }).catch(() => { })
    },
    // 发布
    publishFun (args) {
      if (!args[0]) {
        this.$message({
          message: '请选择数据行',
          type: 'warning'
        })
        return
      } else if (args[0].status !== 1) {
        this.$message({
          message: '单据不在草稿状态，不能发布',
          type: 'warning'
        })
        return
      }
      this.$confirm('是否确定发布该用户消息？', '系统提示',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
          center: true
        }
      ).then(async () => {
        saveOrUpdateAppConsumerMessageApi({ id: args[0].id, isPublish: "1" }).then(res => {
          if (res.mark === '200') {
            this.$message({
              message: res.message,
              type: 'success'
            })
            this.loadTableData()
          }
        })
      }).catch(() => { })
    },
    // 导出数据API
    ExportByPage () {
      let pageCondition = { condition: JSON.stringify(this.exportObj) }
      loadAppConsumerMessageExportDataApi(pageCondition).then(res => {
        let exportObj = { exportSuccess: true, url: res.data }
        this.$store.dispatch('message/settingExportSuccess', exportObj)
      })
    }
  }
}
</script>
